<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<mat-toolbar color="primary"><h1>Searches</h1></mat-toolbar>
<mat-dialog-content fxLayout="column" fxLayoutAlign="start center">
    <button mat-button type="button"
            *ngFor="let search of searches$ | async"
            (click)="choose(search.name)">
        {{ search.displayName }}
    </button>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>
